import samHead from "../img/team/sam.webp";
import alejandraHead from "../img/team/alejandra.webp";
import danHead from "../img/team/dan.webp";
import yasminHead from "../img/team/yasmin.webp";
import emilioHead from "../img/team/emilio.webp";
import austinHead from "../img/team/austin.webp";
import fettiHead from "../img/fetti.png";

export const teamInfo = [
  {
    icon: samHead,
    name: "Samantha Chen",
    title: "CEO",
    description: "Serial Entrepreneur, Engineering @ UC Berkeley (Alumni)",
    linkedin: "https://www.linkedin.com/in/samchenmedia/",
  },
  {
    icon: danHead,
    name: "Dan Su",
    title: "CTO",
    description: "Seasoned Founding Engineer, CS @ UChicago (Alumni) ",
    linkedin: "https://www.linkedin.com/in/dan-su-9ab5a441/",
  },
  {
    icon: emilioHead,
    name: "Emilio Arias",
    // title: "Career Matchmaker - Talent Acquisition Specialist",
    title: "Career Matchmaker - Talent Specialist",
    description: "Ex-Recruiter at Meta, Google, & Uber",
    linkedin: "https://www.linkedin.com/in/emilioarias88/",
  },
  {
    icon: alejandraHead,
    name: "Alejandra",
    title: "Ex-Meta (University Recruiting, DEI) & Handshake",
    description: "Ex-Meta (University Recruiting, DEI) & Handshakes",
    linkedin: "https://www.linkedin.com/in/alejandra-alvarez-/",
  },
  {
    icon: yasminHead,
    name: "Yasmin Xavier",
    title: "Career Matchmaker - Creator",
    description: "News Anchor at Hollywire",
    linkedin: "",
  },
  {
    icon: austinHead,
    name: "Austin",
    title: "Ex-Meta, Airbnb, Google, UC Davis (admissions/recruiting)",
    description: "Ex-Meta, Airbnb, Google, UC Davis (admissions/recruiting)",
    linkedin: "",
  },
  {
    icon: fettiHead,
    name: "Fetti University",
    title: "Former Recruiters from Google, Meta, & more",
    description: "",
    linkedin: "",
  },
  {
    icon: fettiHead,
    name: "Fetti Q&A",
    title: "Former Recruiters from Uber, Airbnb, & more",
    description: "",
    linkedin: "",
  },
];
